import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { PageEmptyState } from '../../PageEmptyState'
import Text from '../../Text'

import { QA_NAME_RENTAL_PORTAL_SETTINGS_LOAD_RETRY } from './RentalPortalSettingsLoadError.constants'

import RefreshIcon from '../../../icons/refresh.svg'
import SettingsIcon from '../../../icons/settings.svg'

function RentalPortalSettingsLoadError({ isLoading, textKey, onClickRetry }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={SettingsIcon}>
      <Text isSecondary>{t(textKey)}</Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        isLoading={isLoading}
        qaName={QA_NAME_RENTAL_PORTAL_SETTINGS_LOAD_RETRY}
        text={t('RentalPortal.ListingRetryBtnKey')}
        onClick={onClickRetry}
      />
    </PageEmptyState>
  )
}

export default RentalPortalSettingsLoadError
